var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 70 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1956_8996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2198 3.76V46H16.3878V13.744L7.23575 19.632L3.20375 13.04L17.1558 3.76H25.2198ZM50.4467 10.6C47.2723 10.1904 45.0451 9.9856 43.7651 9.9856C42.5107 9.9856 41.6915 10.1008 41.3075 10.3312C40.9491 10.5616 40.7699 10.9328 40.7699 11.4448C40.7699 11.9312 41.0131 12.2768 41.4995 12.4816C42.0115 12.6608 43.2915 12.9424 45.3395 13.3264C47.4131 13.6848 48.8851 14.2864 49.7555 15.1312C50.6259 15.976 51.0611 17.3456 51.0611 19.24C51.0611 23.3872 48.4883 25.4608 43.3427 25.4608C41.6531 25.4608 39.6051 25.2304 37.1987 24.7696L35.9699 24.5392L36.1235 20.2384C39.2979 20.648 41.4995 20.8528 42.7283 20.8528C43.9827 20.8528 44.8275 20.7376 45.2627 20.5072C45.7235 20.2512 45.9539 19.88 45.9539 19.3936C45.9539 18.9072 45.7107 18.5488 45.2243 18.3184C44.7635 18.088 43.5347 17.8064 41.5379 17.4736C39.5667 17.1408 38.0947 16.5776 37.1219 15.784C36.1491 14.9904 35.6627 13.5824 35.6627 11.56C35.6627 9.512 36.3539 7.976 37.7363 6.952C39.1187 5.9024 40.8979 5.3776 43.0739 5.3776C44.5843 5.3776 46.6451 5.6208 49.2563 6.1072L50.5235 6.3376L50.4467 10.6ZM66.5624 10.1776H61.8392V18.0496C61.8392 18.8176 61.852 19.368 61.8776 19.7008C61.9288 20.008 62.0696 20.2768 62.3 20.5072C62.556 20.7376 62.94 20.8528 63.452 20.8528L66.3704 20.776L66.6008 24.8848C64.8856 25.2688 63.58 25.4608 62.684 25.4608C60.38 25.4608 58.8056 24.9488 57.9608 23.9248C57.116 22.8752 56.6936 20.9552 56.6936 18.1648V10.1776H54.428V5.8H56.6936V0.462397H61.8392V5.8H66.5624V10.1776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1956_8996",
    x: 0.203735,
    y: 0.461914,
    width: 69.397,
    height: 51.5381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1956_8996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1956_8996",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1St);
export default __webpack_public_path__ + "static/media/1st.7c7b96b033f482aea8edc7093b093b52.svg";
export { ForwardRef as ReactComponent };